import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import LcabApiResult from "~/cabinet/ts/api/LcabApiResult";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";

export default class LcabApiRequestFromOperatorApplication<TData extends object> extends LcabApiRequest<TData> {
    public getUrl(path: string): string {
        let host = OperatorApplicationConfigInstance.isNative ? OperatorApiRequest.getHost() : "";
        return host + super.getUrl(path);
    }

    async send(): Promise<LcabApiResult<TData>> {
        if (!OperatorAccountStore.isCabinetIframe) {
            this.addHeader("X-from-operator-application", "1");
            this.addHeader("X-Token", encodeURIComponent(JSON.stringify({
                login: OperatorAccountStore.login.value,
                password: OperatorAccountStore.password.value,
                tokenId: OperatorAccountStore.tokenId.value
            })));
        }
        return super.send();
    }
}